import { render } from "./entryPage.vue?vue&type=template&id=0b764394&scoped=true"
import script from "./entryPage.vue?vue&type=script&lang=js"
export * from "./entryPage.vue?vue&type=script&lang=js"

import "./entryPage.vue?vue&type=style&index=0&id=0b764394&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b764394"]])

export default __exports__